// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    themes: {
        light: {
            primary: '#23A6E9',
            secondary: '#2B317C',
            accent: '#ED7024',
            error: '#DC3545',
            warning: '#ED7024',
            info: '#009688',
            success: '#8bc34a'
        },
    },
  },
  icons: {
      iconfont: 'md',
  },
})
